<script>

  import {API_CHANGE_PWD} from '../../common/api'

  export default {
    name: 'ChangePwd',
    data() {
      return {
        pwdForm: {
          password: '',
          new_password: '',
          confirm_password: ''
        },
        rules: {
          password: [
            {required: true, message: '原密码不能为空', trigger: 'blur'}
          ],
          new_password: [
            {required: true, message: '新密码不能为空', trigger: 'blur'}
          ],
          confirm_password: [
            {required: true, message: '确认密码不能为空', trigger: 'blur'}
          ],
        },
      }
    },
    methods: {
      changePassword(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            let params = this.pwdForm;
            this.$http.PUT(API_CHANGE_PWD, params,
              res => {
                this.loading = false;
                this.$router.push({path: '/'})
              }, err => {
                this.loading = false;
                this.$message.error(err.msg)
              })
          }
        })
      }
    }
  }

</script>

<template>
  <div class="table_container">
    <el-form ref="pwdForm" :model="pwdForm" :rules="rules" size="small" @submit.native.prevent label-width="100px">
      <el-form-item label="原密码" prop="password">
        <el-input v-model="pwdForm.password" placeholder="请输入原密码" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="new_password">
        <el-input v-model="pwdForm.new_password" placeholder="请输入新密码" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirm_password">
        <el-input v-model="pwdForm.confirm_password" placeholder="请输入确认密码" clearable
                  class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="changePassword('pwdForm')" size="small">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>

  @import '../../assets/styles/table.scss';

  .table_container {
    padding: 20px 0;
  }

</style>



// WEBPACK FOOTER //
// src/page/home/ChangePwd.vue